// In GmailAuthOverlay.js, simplify the component
import React, { useState, useEffect } from "react";
import "../styles/GmailAuthOverlay.css";

const GmailAuthOverlay = ({
  onLoginClick,
  onReturn,
  showReturnButton = true,
}) => {
  // Check if we should show the overlay
  const [isVisible, setIsVisible] = useState(true);
  const [returnButtonText, setReturnButtonText] = useState("Return to Report");

  useEffect(() => {
    // Check if the user is already authenticated with Google
    const authProvider = localStorage.getItem("auth_provider");

    // If they're using Google auth, don't show the overlay
    if (authProvider === "google") {
      setIsVisible(false);
    }

    // Check if we have a report ID in the URL or localStorage
    const urlParams = new URLSearchParams(window.location.search);
    const reportId = urlParams.get("reportId");
    const sharerEmail = localStorage.getItem("sharerEmail");

    // If no report to return to, change the button text
    if (!reportId && !sharerEmail) {
      setReturnButtonText("Go Back");
    }
  }, []);

  // If we should hide the overlay, return null
  if (!isVisible) return null;

  return (
    <div className="gmail-auth-overlay tab-specific">
      <div className="gmail-auth-content">
        <div className="gmail-auth-icon">
          <i className="fas fa-info-circle"></i>
        </div>
        <h3>Full Access Available</h3>
        <p>Sign in with Google to create your own expenses and reports.</p>

        <div className="auth-buttons">
          {showReturnButton && (
            <button
              className="return-btn"
              onClick={onReturn}
              style={{
                fontSize: "16px",
                padding: "10px 20px",
                marginBottom: "15px",
                backgroundColor: "#0066ff",
                color: "#FFD700",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
                width: "100%",
              }}
            >
              {returnButtonText}
            </button>
          )}

          <button
            className="gmail-sign-in-btn"
            onClick={onLoginClick}
            style={{
              fontSize: "14px",
              padding: "8px 16px",
              backgroundColor: "#ffffff",
              color: "#444",
              border: "1px solid #ccc",
              borderRadius: "5px",
              cursor: "pointer",
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <i className="fab fa-google" style={{ marginRight: "8px" }}></i>
            Connect Google Account (Optional)
          </button>
        </div>
      </div>
    </div>
  );
};

export default GmailAuthOverlay;
